import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getCFBargraphData } from 'services/analytics/feedback';

const getData = async ({ cohort, groupByKeys, splitByKeys, dateRange }) => {
  try {
    const res = await getCFBargraphData({
      cohort,
      groupByKeys,
      splitByKeys,
      dateRange,
    });
    const { data } = res ?? {};
    return { data };
  } catch (err) {
    console.error('Error fetching data for CF Bar Chart : ', err);
  }
};
export const useCFBarGraphData = ({ cohort, groupByKeys, splitByKeys, dateRange }) =>
  useQuery(
    [REACT_QUERY_KEYS.CFBarChartData, cohort?.id, groupByKeys?.keyName, splitByKeys, dateRange],
    () =>
      getData({
        cohort,
        groupByKeys,
        splitByKeys,
        dateRange,
      }),
    { enabled: !!cohort && !!groupByKeys && !!splitByKeys && !!dateRange?.startTS }
  );
